import Vue from 'vue';

import VueRouter from 'vue-router';
import AlertComponent from './common/alert/AlertComponent.vue';
import VeeValidateHelper from './vendor/vee-validate/VeeValidateHelper';
import Locale from './common/localization/Locale';
import store from './administration/pages/vuex/store';
import VcomProvider from './VcomProvider';
import systemLevelRoutes from './administrationMenu/const/systemLevel/Routes';
import parkLevelRoutes from './administrationMenu/const/parkLevel/Routes';

export default async function vueInstanceSetup() {
  VeeValidateHelper.installVeeValidateRules();
  await VeeValidateHelper.localizeVeeValidate(Locale.getLanguageCode());

  Vue.customElement('tour-modal', async () => {
    const { default: component } = await import('./vcom/tour/TourModal.vue');
    return component;
  });

  Vue.customElement('work-order-create', async () => {
    const { default: component } = await import('./cmms/workorder/WorkOrderCreate.vue');
    return component;
  });

  Vue.customElement(
    'documents-tree-modal',
    async () => {
      const { default: component } = await import('./cmms/documents/DocumentsTreeModal.vue');
      return component;
    },
    { props: ['modalTitle'] },
  );

  Vue.customElement('administration-menu', async () => {
    const { default: component } = await import('./administrationMenu/AdministrationMenu.vue');
    const routes = VcomProvider.adminSystemId ? systemLevelRoutes : parkLevelRoutes;
    component.router = new VueRouter({ routes });
    component.store = store;
    return component;
  }, { props: ['open-base'] });

  /**
   * The following components are used in "zf/Vcom_application/layouts/scripts/layout.phtml"
   * and therefore lazy loading has no positive effect
   */
  Vue.customElement('alert-component', AlertComponent);
}
